import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../../Calculators/RangeSplitter";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Summary_2_Header({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Detect if RGB color system is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);
  let splitRanges = GetBeforeAndAfterHitRanges(item?.scale.ranges);
  const filledPart =
    ((elementScore - splitRanges.hitRange?.start) / (splitRanges.hitRange?.end - splitRanges.hitRange?.start)) * 100;

  return (
    <Row className={"mb-3 mx-0"}>
      <div className="summary-scaleless-container-wrap-up">
        <Row>
          <Col xs={4}>
            <Row>
              <Col
                xs={"auto"}
                className={`align-content-center pt-0 ${isSub ? "detail-section-sub-scope-name-header-wrap-up" : "detail-section-scope-name-header-wrap-up"}`}
              >
                {item.name}
              </Col>
              <Col xs={"auto"}>
                <div
                  className={isSub ? "detail-sub-scope-score-header-wrap-up" : "detail-main-scope-score-header-wrap-up"}
                >
                  {elementScore}
                </div>
              </Col>
            </Row>
          </Col>

          <Col xs={8} className={"align-content-center"} style={{ paddingRight: "38px" }}>
            <Row>
              {splitRanges.beforeHitRangeList.map((range, i) => {
                return (
                  <Col key={"before" + i} className={" px-0 align-content-center"}>
                    <ProgressBar
                      className={
                        rgbEnabled
                          ? isSub
                            ? "sub-scale-style-thin-header"
                            : "scale-style-thin-header"
                          : isSub
                            ? "sub-scale-style-thin-header"
                            : "scale-style-thin-header"
                      }
                      style={
                        rgbEnabled
                          ? {
                              height: "12px",
                              margin: "0 2px",
                              backgroundColor: colors.light,
                            }
                          : { height: "12px", margin: "0 2px", backgroundColor: "#ffffff" }
                      }
                      now={100}
                    ></ProgressBar>
                  </Col>
                );
              })}
              <Col className={" p-0 align-content-center"}>
                <ProgressBar
                  className={
                    rgbEnabled
                      ? isSub
                        ? "sub-scale-style-thin-header"
                        : "scale-style-thin-header"
                      : isSub
                        ? "sub-scale-style-thin-header"
                        : "scale-style-thin-header"
                  }
                  style={
                    rgbEnabled
                      ? {
                          height: "12px",
                          margin: "0 2px",
                          backgroundColor: colors.light,
                        }
                      : { height: "12px", margin: "0 2px", backgroundColor: "#ffffff" }
                  }
                  now={filledPart}
                ></ProgressBar>
              </Col>
              {splitRanges.afterHitRangeList.map((range, i) => {
                return (
                  <Col key={"after" + i} className={" px-0 align-content-center"}>
                    <ProgressBar
                      className={isSub ? "sub-scale-style-thin-header" : "scale-style-thin-header"}
                      style={{ height: "12px", margin: "0 2px", backgroundColor: "#ffffff" }}
                      now={0}
                    ></ProgressBar>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
